import React from "react";
import { convertToKoreanNumber } from "../../../../utils/timer";
import { StructuresResponse } from "../../../tournament/hook/useEditTournament";

interface BlindDisplayProps {
  smallBlind: number;
  bigBlind: number;
  ante: number;
  type: "LEVEL" | "BREAK" | string;
}

const BlindDisplay: React.FC<BlindDisplayProps> = ({
  smallBlind,
  bigBlind,
  ante,
  type,
}) => {
  if (type === "BREAK") return <div className="now-blinds">BREAK</div>;

  return (
    <>
      <div className="now-blinds">
        {`${convertToKoreanNumber(smallBlind)}/${convertToKoreanNumber(
          bigBlind,
        )}(${convertToKoreanNumber(ante)})`}
      </div>
    </>
  );
};

interface BlindInfoProps {
  title: string;
  smallBlind: number;
  bigBlind: number;
  ante: number;
  type: "LEVEL" | "BREAK" | string;
  isNext?: boolean;
}

const BlindInfo: React.FC<BlindInfoProps> = ({
  title,
  smallBlind,
  bigBlind,
  ante,
  type,
  isNext,
}) => {
  const blindClassName =
    isNext && smallBlind > 100000 ? "next-blinds big" : "next-blinds";

  return (
    <div className={`${isNext ? "next-blind-wrapper" : "now-blind-wrapper"}`}>
      <div className="title">{title}</div>
      <div className="value">
        <div className={blindClassName}>
          <BlindDisplay
            smallBlind={smallBlind}
            bigBlind={bigBlind}
            ante={ante}
            type={type}
          />
        </div>
      </div>
    </div>
  );
};

interface BlindInfoContainerProps {
  currentLevel: StructuresResponse | null;
  nextLevel: StructuresResponse | null;
  isGameStarted: boolean;
}

const BlindInfoContainer: React.FC<BlindInfoContainerProps> = ({
  currentLevel,
  nextLevel,
  isGameStarted,
}) => {
  if (!currentLevel) {
    return null;
  }

  if (currentLevel.ord === 1) {
    return (
      <>
        <BlindInfo
          title="현재 BLINDS"
          smallBlind={currentLevel.smallBlind || 0}
          bigBlind={currentLevel.bigBlind || 0}
          ante={currentLevel.ante || 0}
          type={currentLevel.type}
        />
        {nextLevel && (
          <BlindInfo
            title="다음 BLINDS"
            smallBlind={nextLevel.smallBlind || 0}
            bigBlind={nextLevel.bigBlind || 0}
            ante={nextLevel.ante || 0}
            type={nextLevel.type}
            isNext={true}
          />
        )}
      </>
    );
  }

  if (!isGameStarted) {
    return null;
  }

  return (
    <>
      <BlindInfo
        title="현재 BLINDS"
        smallBlind={currentLevel.smallBlind || 0}
        bigBlind={currentLevel.bigBlind || 0}
        ante={currentLevel.ante || 0}
        type={currentLevel.type}
      />
      {nextLevel && (
        <BlindInfo
          title="다음 BLINDS"
          smallBlind={nextLevel.smallBlind || 0}
          bigBlind={nextLevel.bigBlind || 0}
          ante={nextLevel.ante || 0}
          type={nextLevel.type}
          isNext={true}
        />
      )}
    </>
  );
};

export default BlindInfoContainer;
